import { Config } from '../config';
import { Form } from './form';
import { RecaptchaV3View } from '../view/recaptcha-v3-view';
import { Order } from '../config/order';
import { FormTypes } from './form-types';

export class RecaptchaV3Form  extends Form {

    type = FormTypes.RecaptchaV3;
    view: RecaptchaV3View = new RecaptchaV3View();

    constructor() {
        super();
    }
    
    init = async (config: Config, callback: any) => {
        await super.init(config, callback);
        return this.loadScript(`https://www.google.com/recaptcha/api.js?render=${process.env.RECAPTCHA_V3_SITE_KEY}`)
            .then(() => Promise.resolve());
    }

    render = () => {
        const isFormRecaptchaEnabled = this.config.recaptchaCheckboxEnabled && this.config.recaptchaCheckboxEnabled === true;
        this.view.render(isFormRecaptchaEnabled);
        return Promise.resolve();
    }

    fetchToken = () => {
        this.view.fetchToken();
    }

    getGrecaptchaInstance = () => {
        return this.view.getGrecaptchaInstance();
    }

    getTokenV3 = () => {
        return this.view.tokenV3;
    }

    submit(order: Order) {
        order.recaptchaTokenV3 = this.getTokenV3();
        return Promise.resolve(order);
    }

}
